import { NavigationCardVariantType } from '../../../../../../components/navigationCard/types/navigationCard';
import { NavigationCardOptionType } from '../../../../../../components/navigationCard/types/option';
import { NavigationCardStateType } from '../../../../../../components/navigationCard/types/state';
import { TagVariantType } from '../../tag/variants';
import { elementsContainerCommonStyles, firstCommonStyles, lastCommonStyles, middleCommonStyles, parentContainerCommonStyles, stateCommonStyles, uniqueCommonStyles, } from '../commonStyles';
const stateHorizontalCommonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    ...stateCommonStyles(FOUNDATIONS, FONT, STATE_TOKENS),
    parentContainer: {
        ...parentContainerCommonStyles(FOUNDATIONS, FONT),
        flex_direction: 'row',
        text_align: 'left',
        padding: `${FOUNDATIONS.spacing_250}`,
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.parentContainer,
    },
    elementsContainer: {
        ...elementsContainerCommonStyles(FOUNDATIONS, FONT),
        align_items: 'left',
    },
    iconHighlighted: {
        backgroundColor: FOUNDATIONS.color_comp_navigation_navigationcard_bgiconhighlighted,
        ...STATE_TOKENS.iconHighlighted,
    },
    tag: {
        variant: TagVariantType.INFORMATIVE,
        ...STATE_TOKENS.tag,
    },
    leftIconContainer: {
        align_self: 'flex-start',
        ...STATE_TOKENS.iconContainer,
    },
});
const optionHorizontalCommonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    [NavigationCardStateType.DEFAULT]: {
        ...stateHorizontalCommonStyles(FOUNDATIONS, FONT, {
            ...STATE_TOKENS[NavigationCardStateType.DEFAULT],
            parentContainer: {
                background_color: FOUNDATIONS.color_comp_containers_bg,
                ...STATE_TOKENS[NavigationCardStateType.DEFAULT]?.parentContainer,
            },
        }),
    },
    [NavigationCardStateType.PRESSED]: {
        ...stateHorizontalCommonStyles(FOUNDATIONS, FONT, {
            ...STATE_TOKENS[NavigationCardStateType.PRESSED],
            parentContainer: {
                background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                ...STATE_TOKENS[NavigationCardStateType.PRESSED]?.parentContainer,
            },
        }),
    },
    [NavigationCardStateType.DISABLED]: {
        ...stateHorizontalCommonStyles(FOUNDATIONS, FONT, {
            ...STATE_TOKENS[NavigationCardStateType.DISABLED],
            parentContainer: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                cursor: 'default',
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.parentContainer,
            },
            label: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.label,
            },
            title: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.title,
            },
            description: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.description,
            },
            helperText: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.helperText,
            },
            leftIcon: {
                color: FOUNDATIONS.color_accent_disabled_icon_50,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.leftIcon,
            },
            rightIcon: {
                color: FOUNDATIONS.color_accent_disabled_icon_50,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.rightIcon,
            },
            iconHighlighted: {
                backgroundColor: FOUNDATIONS.color_comp_navigation_navigationcard_bgiconhighlighted,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.iconHighlighted,
            },
            tag: {
                variant: TagVariantType.DISABLED,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.tag,
            },
            distanceLabel: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
                ...STATE_TOKENS[NavigationCardStateType.DISABLED]?.distanceLabel,
            },
        }),
    },
});
export const getHorizontalStyles = (FOUNDATIONS, FONT) => {
    return {
        [NavigationCardVariantType.HORIZONTAL]: {
            [NavigationCardOptionType.UNIQUE]: {
                ...optionHorizontalCommonStyles(FOUNDATIONS, FONT, {
                    ...uniqueCommonStyles(FOUNDATIONS),
                }),
            },
            [NavigationCardOptionType.FIRST]: {
                ...optionHorizontalCommonStyles(FOUNDATIONS, FONT, {
                    ...firstCommonStyles(FOUNDATIONS),
                }),
            },
            [NavigationCardOptionType.MIDDLE]: {
                ...optionHorizontalCommonStyles(FOUNDATIONS, FONT, {
                    ...middleCommonStyles(FOUNDATIONS),
                }),
            },
            [NavigationCardOptionType.LAST]: {
                ...optionHorizontalCommonStyles(FOUNDATIONS, FONT, {
                    ...lastCommonStyles(FOUNDATIONS),
                }),
            },
        },
    };
};
//# sourceMappingURL=horizontal.js.map